namespace Matrix.Administration {
    export interface GroupForm {
        GroupId: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        GroupType: Serenity.StringEditor;
        Roles: FormatLookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class GroupForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.Group';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GroupForm.init)  {
                GroupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatLookupEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(GroupForm, [
                    'GroupId', w0,
                    'Name', w0,
                    'GroupType', w0,
                    'Roles', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
